<template>
  <v-expansion-panels
    focusable
    v-model="panel"
    @change="search = ''"
  >
    <v-progress-linear indeterminate v-show="loading" />
    <v-expansion-panel
      v-for="(estruturaBase, key) in estruturasBases"
      :key="key"
      :disabled="loading"
    >
      <v-expansion-panel-header>
        {{estruturaBase.nome}}
        <v-text-field
          v-if="key === panel"
          v-model="search"
          append-icon="mdi-magnify"
          label="Procurar"
          hide-details
          single-line
          dense
          class="mx-10 mt-0"
          @click.stop=""
        />
      </v-expansion-panel-header>
      <v-expansion-panel-content class="content-expansion-p-rel-customizado">
        <v-data-table
          v-if="'estrutura' in estruturaBase"
          class="table-rel-customizado"
          :headers="headers"
          :items="estruturaBase.estrutura"
          :items-per-page="-1"
          :mobile-breakpoint="0"
          :search.sync="search"
          disable-sort
          hide-default-footer
          dense
        />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import TabelasService from '@/services/TabelasService';

export default {
  data: () => ({
    estruturasBases: [],
    panel: [],
    headers: [
      { text: 'Campo', value: 'Field' },
      { text: 'Tipo', value: 'Type' },
      { text: 'Nulo', value: 'Null' },
      { text: 'Chave', value: 'Key' },
      { text: 'Padrão', value: 'Default' },
      { text: 'Extras', value: 'Extra' },
    ],
    search: [],
    loading: false
  }),

  mounted() {
    this.getEstruturaBasesDadosLiberadas();
  },

  methods: {
    getEstruturaBasesDadosLiberadas() {
      this.loading = true;

      TabelasService.getEstruturaBasesDadosLiberadas()
      .then(response => this.estruturasBases = response.data.data)
      .catch(error => {
        console.log(error)
        this.$toast.error('Erro ao recuperar bases de dados liberadas.', '',{position:'topRight'})
      })
      .finally(() => this.loading = false);
    },

    getEstrutura(tabela) {
      this.loading = true;

      return TabelasService.getEstrutura(tabela)
      .then(response => response.data.data)
      .catch(error => {
        console.log(error)
        this.$toast.error('Erro ao recuperar estrutura da bases de dados.', '',{position:'topRight'})
      })
      .finally(() => this.loading = false);
    },

    async manageEstruturaTabela(position) {
      let baseInfo = this.estruturasBases[position];
      if (baseInfo && 'estrutura' in baseInfo == false) {
        this.$set(this.estruturasBases[position], 'estrutura', await this.getEstrutura(baseInfo.nome));
      }
    }
  },

  watch: {
    panel: {
      handler(index) {
        this.manageEstruturaTabela(index);
      },
      deep: true
    }
  }
}
</script>

<style>
  .content-expansion-p-rel-customizado .v-expansion-panel-content__wrap {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
  .table-rel-customizado table tr td {
    font-size: 11px !important;
    font-weight: 400;
  }
  .table-rel-customizado table tr th {
    font-size: 11px !important;
    font-weight: bold !important;
    color: #E5502C !important;
  }
</style>